import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@newfront-insurance/core-ui/v2';
import { useId } from 'react';

import type { SettingsGroup } from '../../../../queries/skill-administration';

/** Parent selection belongs to team creation; Settings lists show all organizations. */
export function TeamOrganizationField({
  organizations,
  organization,
  onChange,
  disabled,
}: {
  organizations: readonly SettingsGroup[];
  organization: SettingsGroup | null;
  onChange: (uuid: string) => void;
  disabled?: boolean;
}) {
  const labelId = useId();
  return (
    <div className="flex min-w-0 flex-col gap-2" role="group" aria-labelledby={labelId}>
      <span id={labelId} className="text-steel-500 text-base font-semibold">
        Organization
      </span>
      {organizations.length === 1 && organization ? (
        <p className="text-steel-500 text-base break-words">{organization.name}</p>
      ) : (
        <Select value={organization?.uuid ?? ''} onValueChange={onChange} disabled={disabled}>
          <SelectTrigger aria-labelledby={labelId} className="w-full">
            <SelectValue placeholder="Choose an organization" />
          </SelectTrigger>
          <SelectContent>
            {organizations.map((group) => (
              <SelectItem key={group.uuid} value={group.uuid}>
                {group.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </div>
  );
}
